<script lang="ts" setup>
import { CommonDateTime } from '#components'

defineProps<{
  match: CompetitionMatch
}>()
const context = await useContext().fetchContext()
</script>

<template>
  <NuxtLink
    :to="$getPathFor(`/matches/` + match.slug, context.urlBase)"
    class="cursor-pointer"
  >
    <Card>
      <template #content>
        <div class="flex flex-col gap-1 md:gap-2">
          <div class="flex justify-between items-center">
            <div class="flex-1 truncate">
              {{ match.home_team?.name }}
            </div>
            <div class="flex md:gap-2 items-center">
              <span class="font-bold">{{ match.home_score ?? '-' }}</span>
              -
              <span class="font-bold">{{ match.visitor_score ?? '-' }}</span>
            </div>
            <div class="flex-1 text-right truncate">
              {{ match.away_team?.name }}
            </div>
          </div>
          <div class="flex justify-between items-center text-sm md:flex-row flex-col">
            <CommonDateTime :date="match.datetime" />
            <Tag
              :severity="match.status === 'complete' ? 'success' : match.status === 'started' ? 'info' : 'secondary'"
            >
              <template v-if="match.status === 'not_started'">
                {{ $t('Not started') }}
              </template>
              <template v-else-if="match.status === 'started'">
                {{ $t('In play') }}
              </template>
              <template v-else-if="match.status === 'complete'">
                {{ $t('Complete') }}
              </template>
            </Tag>
          </div>
        </div>
      </template>
    </Card>
  </NuxtLink>
</template>
